import React from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import Online from 'components/Online';
import SchemasWithoutEventTypeIdExistGate from 'components/SchemasWithoutEventTypeIdExistGate';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import RoleGate from 'components/RoleGate';
import ErrorGate from 'components/ErrorGate';

// @ts-ignore
import { DOCUMENT_SET_LOAD_NAMESPACE } from 'services/documentSets/constants';

// @ts-ignore
import DocumentSetEventSchemaName from '../../components/DocumentSetEventSchemaName';
// @ts-ignore
import DocumentSetEventEntityHierarchy from '../../components/DocumentSetEventEntityHierarchy';
import DocumentSetExistsGate from '../../components/DocumentSetExistsGate';
import DocumentSetRequest from '../../components/DocumentSetRequest';
import JobDetails from './components/JobDetails';
import JobAssessmentScores from './components/JobAssessmentScores';
import JobAssessments from './components/JobAssessments';

import './styles.scss';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

type Props = RouteComponentProps<{ documentSetId: string }>;

class Job extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            match: {
                params: { documentSetId }
            }
        } = this.props;
        const id = parseInt(documentSetId, 10);

        return (
            <ErrorBoundary
                namespace="Job"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                    <SchemasWithoutEventTypeIdExistGate
                        FallbackComponent={<Redirect to="/" />}
                    >
                        <Online>
                            <DocumentSetRequest documentSetId={id} />
                        </Online>
                        <Helmet>
                            <title>Job - {REACT_APP_PROJECT_NAME}</title>
                        </Helmet>
                        <ErrorGate
                            namespace={DOCUMENT_SET_LOAD_NAMESPACE}
                            FallbackComponent={
                                <Redirect to="/organization/jobs/planner" />
                            }
                        >
                            <DocumentSetExistsGate
                                documentSetId={id}
                                fallbackComponent={
                                    <LoadingGate
                                        namespace={DOCUMENT_SET_LOAD_NAMESPACE}
                                        LoadingComponent={
                                            <PageWrapper top={100}>
                                                <Loader
                                                    active
                                                    inline="centered"
                                                />
                                            </PageWrapper>
                                        }
                                    />
                                }
                            >
                                <PageTitleAndFilters
                                    title={
                                        <React.Fragment>
                                            <DocumentSetEventSchemaName
                                                documentSetId={id}
                                            />
                                            &nbsp; #{id}
                                        </React.Fragment>
                                    }
                                    CustomSearch={
                                        <DocumentSetEventEntityHierarchy
                                            documentSetId={id}
                                        />
                                    }
                                    backTo="/organization/jobs/planner"
                                />
                                <PageWrapper top={0}>
                                    <JobDetails documentSetId={id} />
                                    <JobAssessmentScores documentSetId={id} />
                                    <JobAssessments documentSetId={id} />
                                </PageWrapper>
                            </DocumentSetExistsGate>
                        </ErrorGate>
                    </SchemasWithoutEventTypeIdExistGate>
                </RoleGate>
            </ErrorBoundary>
        );
    }
}

export default withRouter(Job);
